module.exports = __webpack_public_path__ + "Gotham-Book.ee1c47000abc878dca9b.woff";


//////////////////
// WEBPACK FOOTER
// /code/frontend/src/assets/fonts/Gotham-Book.woff
// module id = ../../../../../src/assets/fonts/Gotham-Book.woff
// module chunks = 2